<template>
  <div>
    <!-- 営業曜日表示 -->
    <div class="working-days-container">
      <!-- お預かり先の営業曜日 -->
      <YhcServiceLevelDaysSlot
        title="お預かり先"
        :regular-working-days="fromRegularWorkingDays"
        :revision-note="fromRevisionNote"
        :span-note="fromSpanNote"
        :span-period-label="fromSpanPeriodLabel"
      >
        <template
          v-if="fromSpanNote"
          #spanPreview
        >
          <YhcServiceLevelDaysSlot
            v-if="fromSpanWorkingDays"
            hide-header
            :regular-working-days="fromSpanWorkingDays"
          />
          <p
            v-else
            class="span-preview-fallback"
          >
            営業日を表示できません
          </p>
        </template>
      </YhcServiceLevelDaysSlot>

      <!-- お届け先の営業曜日 -->
      <YhcServiceLevelDaysSlot
        title="お届け先"
        :regular-working-days="toRegularWorkingDays"
        :revision-note="toRevisionNote"
        :span-note="toSpanNote"
        :span-period-label="toSpanPeriodLabel"
      >
        <template
          v-if="toSpanNote"
          #spanPreview
        >
          <YhcServiceLevelDaysSlot
            v-if="toSpanWorkingDays"
            hide-header
            :regular-working-days="toSpanWorkingDays"
          />
          <p
            v-else
            class="span-preview-fallback"
          >
            営業日を表示できません
          </p>
        </template>
      </YhcServiceLevelDaysSlot>
    </div>

    <!-- FGランク利用不可の注釈 -->
    <div
      v-if="showFgRankUnavailableNote"
      class="yhc-service-level-info__unavailable-note"
    >
      {{ fgRankUnavailableNoteText }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { ModelYhcRegularWorkingDays } from '../../../../models/fireModels/yhcDataTypes'
import YhcServiceLevelDaysSlot from './YhcServiceLevelDaysSlot.vue'
import {
  resolveEffectiveRankDisplayMode,
  fgRankUnavailableNoteText as getFgRankUnavailableNoteText,
  type CorporationRankDisplayMode,
} from '../utils/yhcServiceLevelRankDisplayMode'

export default defineComponent({
  name: 'YhcServiceLevelDays',
  components: {
    YhcServiceLevelDaysSlot,
  },
  props: {
    fromRegularWorkingDays: {
      type: Object as PropType<ModelYhcRegularWorkingDays | null>,
      default: null,
    },
    toRegularWorkingDays: {
      type: Object as PropType<ModelYhcRegularWorkingDays | null>,
      default: null,
    },
    isFgRankAvailable: {
      type: Boolean,
      default: true,
    },
    rankDisplayMode: {
      type: String as () => CorporationRankDisplayMode,
      default: 'both',
    },
    isCorporationView: {
      type: Boolean,
      default: false,
    },
    fromRevisionNote: {
      type: String,
      default: '',
    },
    toRevisionNote: {
      type: String,
      default: '',
    },
    fromSpanNote: {
      type: String,
      default: '',
    },
    toSpanNote: {
      type: String,
      default: '',
    },
    fromSpanPeriodLabel: {
      type: String,
      default: '',
    },
    toSpanPeriodLabel: {
      type: String,
      default: '',
    },
    fromSpanWorkingDays: {
      type: Object as PropType<ModelYhcRegularWorkingDays | null>,
      default: null,
    },
    toSpanWorkingDays: {
      type: Object as PropType<ModelYhcRegularWorkingDays | null>,
      default: null,
    },
  },
  computed: {
    effectiveRankDisplayMode(): CorporationRankDisplayMode {
      return resolveEffectiveRankDisplayMode(
        this.rankDisplayMode,
        this.isCorporationView,
      )
    },
    showFgRankUnavailableNote(): boolean {
      if (this.isFgRankAvailable) return false
      if (this.effectiveRankDisplayMode === 'e_only') return false
      return true
    },
    fgRankUnavailableNoteText(): string {
      return getFgRankUnavailableNoteText(this.effectiveRankDisplayMode)
    },
  },
})
</script>

<style>
/* 営業曜日表示のスタイル */
.working-days-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 0.5rem;
}

.yhc-service-level-info__unavailable-note {
  color: #dc3545; /* 赤系の色 */
  font-size: 0.875rem;
  margin-top: 4px;
}
</style>
